// Boas-vindas — a primeira fala do VITA.
//
// A pergunta ("Oi, {nome}! Eu sou o VITA…") é escrita pelo chat, não por
// aqui: quem a guarda é `conversa.js`. Este step só oferece as duas opções e
// grava a escolha, para que a bolha da resposta apareça no histórico como em
// qualquer outra pergunta.
//
// `ONBOARDING_ENTRADA` é um campo NOVO no blob de respostas. O
// `saveUserObjective` grava o objeto inteiro, então não há contrato a mudar;
// quem não conhece o campo simplesmente o ignora.

import React, { useEffect, useState } from "react";

import { Opcoes } from "../widgets/Widgets.jsx";

const OPCOES = [
  { value: "completo", label: "Bora!" },
  { value: "so_treino", label: "Quero só o treino por enquanto" },
];

const StepWelcome = ({ setCanProceed, setStepData }) => {
  const [escolha, setEscolha] = useState("");

  useEffect(() => {
    const valido = Boolean(escolha);
    setCanProceed(valido);
    setStepData(valido ? { ONBOARDING_ENTRADA: escolha } : null);
  }, [escolha, setCanProceed, setStepData]);

  return <Opcoes opcoes={OPCOES} valor={escolha} onSelecionar={setEscolha} numeradas={false} />;
};

export default StepWelcome;
